import { useTranslation } from "react-i18next";

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-foreground-950 rounded-[32px] p-8 md:p-12 overflow-visible">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0 w-40 h-56 md:w-48 md:h-64 -mt-16 md:-mt-20 md:-ml-4 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Young%20Asian%20female%20reading%20webtoon%20on%20smartphone%2C%20cozy%20cafe%20setting%2C%20warm%20ambient%20lighting%2C%20genuine%20happy%20expression%2C%20portrait%20photography%20style%2C%20soft%20bokeh%20background%2C%20natural%20lifestyle%20shot%2C%20casual%20outfit&width=480&height=640&seq=testimonial-reader&orientation=portrait"
                alt="漫迷读者"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="flex-1">
              <span className="text-4xl md:text-5xl text-amber-300 leading-none">"</span>
              <p className="mt-2 text-base md:text-lg text-gray-200 leading-relaxed">
                {t("testimonial.quote")}
              </p>
              <div className="mt-5">
                <p className="text-sm font-semibold text-white">
                  {t("testimonial.name", "小樱花")}
                </p>
                <p className="text-xs text-gray-400 mt-0.5">
                  {t("testimonial.role", "资深漫迷 · 3年老用户")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}